var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakePhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.54,
    height: 15.101,
    viewBox: "0 0 16.54 15.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-add-a-photo",
    "data-name": "Icon material-add-a-photo",
    d: "M2.157,3.657V1.5H3.6V3.657H5.753V5.1H3.6V7.253H2.157V5.1H0V3.657ZM4.315,7.972V5.815H6.472V3.657h5.034L12.822,5.1H15.1A1.442,1.442,0,0,1,16.54,6.534v8.629A1.442,1.442,0,0,1,15.1,16.6H3.6a1.442,1.442,0,0,1-1.438-1.438V7.972Zm5.034,6.472a3.6,3.6,0,1,0-3.6-3.6A3.6,3.6,0,0,0,9.348,14.444Zm-2.3-3.6a2.3,2.3,0,1,0,2.3-2.3A2.3,2.3,0,0,0,7.047,10.848Z",
    transform: "translate(0 -1.5)",
    fill: "#828b9b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhoto);
export default __webpack_public_path__ + "static/media/take_photo.5fe26b0d975ae0a5e73f80c6d0910605.svg";
export { ForwardRef as ReactComponent };